// Example: app/utils/get-filler-image.ts

const brandImageMap: Record<string, string> = {
  '3BROS': '3BROS.webp',
  '710 LABS': '710LABS.webp',
  '710LABS': '710LABS.webp',
  '7 LEAVES': '7Leaves.webp',
  ABX: 'ABX.webp',
  'ALIEN LABS': 'ALIENLABS.webp',
  ALMORA: 'ALMORA.webp',
  'ALMORA FARM': 'ALMORA.webp',
  'AMERICAN WEED CO': 'AMERICA_SWEEDCOMPANY.webp',
  'WEED BY AMERICAN WEED CO': 'AMERICA_SWEEDCOMPANY.webp',

  ASTRONAUTS: 'ASTRONAUTS.webp',
  ATOMICCITY: 'ATOMICCITY.webp',
  'BAGGIE BUDS': 'BAGGIE BUDS.webp',
  BINSKE: 'BINSKE.webp',
  BLOOM: 'BLOOM.webp',
  'BOHEMIAN CHEMIST': 'THEBOHEMIANCHEMIST.webp',
  'BRITE LABS': 'BRITE.webp',
  CAMINO: 'CAMINO.webp',
  CANN: 'CANN.webp',
  CANNABIOTIX: 'CANNABIOTIX.webp',
  'CARE BY DESIGN': 'CAREBYDESIGN.webp',
  CBX: 'CBX.webp',
  CHEMISTRY: 'CHEMISTRY.webp',
  'CHERRY WORLD': 'CHERRYWORLD.webp',
  'CHICOS BEST': 'CHICOSBEST.webp',
  "CHICO'S BEST": 'CHICOSBEST.webp',
  SLUGGERS: 'Untitled-1.png.webp',
  'CLAYBOURNE CO': 'CLAYBOURNE.webp',
  'CLONE GUY': 'CLONEGUY.webp',
  'CONNECTED CANNABIS CO': 'CONNECTEDCANNABISCO.webp',
  'CREAM OF THE CROP': 'CREAMOFTHECROP.webp',
  DABWOODS: 'DABWOODS.webp',
  'DECIBEL GARDENS': 'DECIBELGARDENS.webp',
  'DEE THAI': 'DEETHAI.png.webp',
  DELIGHTED: 'DELIGHTED.webp',
  'EMERALD SKY': 'EMERALDSKY.webp',
  'FIG FARMS': 'FIG FARMS.webp',
  FLEETWOOD: 'FLEETWOOD.png.webp',
  'GARDEN SOCIETY': 'GARDENSOCIETY.webp',
  GELATO: 'GELATO.webp',
  HALARA: 'HALARA.webp',
  'HALARA EXTRACTS': 'HALARA.webp',
  'HUMBOLDT FAMILY FARMS': 'HUMBOLDTFAMILYFARMS-1.webp',

  "HENRY'S ORIGINAL": 'HENRYS.webp',
  'HEAVY HITTERS': 'HEAVYHITTERS.webp',
  HIGHATUS: 'HIGHATUS.webp',
  HUSH: 'HUSH.webp',
  JEETER: 'JEETER.webp',
  JETPACKS: 'JETPACKS.webp',
  JETTYEXTRACTS: 'JETTYEXTRACTS.webp',
  KANHA: 'KANHA.webp',
  KEEF: 'KEEF.webp',
  KIKOKO: 'KIKOKO.webp',
  KINGPEN: 'KINGPEN.webp',
  KINGROLL: 'KINGROLL.webp',
  KINGSGARDEN: 'KINGSGARDEN.webp',
  KIVA: 'KIVA.webp',
  KURVANA: 'KURVANA.webp',
  LEVEL: 'LEVEL.webp',
  LIFTTICKETS: 'LIFTTICKETS.webp',
  LIME: 'LIME.webp',
  LOLO: 'LOLO.webp',
  'LOST FARM': 'LOST-FARM-1.webp',
  LOUDPACK: 'LOUDPACK.webp',
  LUMPYS: 'LUMPYS.webp',
  "LUMPY'S": 'LUMPYS.webp',
  LUVBUDS: 'LUVBUDS.webp',
  "MARY'S MEDICINALS": 'MARYS.webp',
  MOONMADE: 'MOONMADE.webp',
  'MR ZIPS': 'MRZIPS.webp',
  MUHAMEDS: 'MUHAMEDS.webp',
  'MUHA MEDS': 'MUHAMEDS.webp',
  OAKFRUITLAND: 'OAKFRUITLAND.webp',
  OCB: 'OCB.webp',
  'PAPA & BARKLEY': 'PB-1.webp',
  'PAPAS SELECT': 'PAPASSELECT.webp',
  PETRA: 'PETRA.webp',
  PLUS: 'PLUS.webp',
  PROOF: 'PROOF.webp',
  PUNCH: 'PUNCH.webp',
  'PUNCH EXTRACTS': 'PUNCH.webp',
  'PURE BEAUTY': 'PUREBEAUTY.webp',
  RANDYS: 'RANDYS.webp',
  'RAW GARDEN': 'RAWGARDEN.webp',
  REVELRY: 'REVELRY.webp',
  RYTHM: 'RYTHM.webp',
  'SANCTUARY FARMS': 'SANCTUARY FARMS.webp',
  SHERBINSKIS: 'SHERBINSKIS.webp',
  SLIMMIES: 'SLIMMIES.webp',
  SONDER: 'SONDER.webp',
  SONOMAHILLSFARM: 'SONOMAHILLSFARM.webp',
  SPACEGEM: 'SPACEGEM.webp',
  STIDES: 'STIDES.webp',
  STIIIZY: 'STIIIZY.webp',
  STUF: 'STUF.webp',
  TALKINGTREES: 'TALKINGTREES.webp',
  TIMELESS: 'TIMELESS.webp',
  TRADITIONAL: 'TRADITIONAL.webp',
  TURN: 'TURN.png.webp',
  "UNCLE ARNIE'S": 'unclearnies.webp',
  URSA: 'URSA.webp',
  'WEST COAST CURE': 'WESTCOASTCURE.webp',
  'WEST COAST TRADING COMPANY': 'WESTCOASTTRADINGCOMPANY.webp',
  WOX: 'WOX.webp',
  WYLD: 'WYLD.webp',
  YADAYADA: 'YADA.webp',
  'YADA YADA': 'YADA.webp',

  ZOMBI: 'ZOMBI.webp',
  PLUGPLAY: 'PLUGPLAY.webp',
};

export default brandImageMap;

// Brands whose logo asset is white / near-white on a transparent background.
// These vanish when shown as the image fallback on a product card (white bg),
// so consumers render them on a contrasting tile (and drop mix-blend-multiply).
// Add a brand here (normalised: UPPERCASE, trimmed) if its logo is light.
export const LIGHT_BRAND_LOGOS = new Set<string>(['CAT4', 'MJUICE']);

/** True when this brand's logo is white/light and needs a dark tile to be seen. */
export const isLightBrandLogo = (brand?: string | null): boolean =>
  !!brand && LIGHT_BRAND_LOGOS.has(brand.toUpperCase().trim());

export const MJUICE_LOGO_URL = 'https://mjuice.vercel.app/assets/logos/logo.webp';

export const brandLogoBackground = (brand?: string | null): string =>
  brand?.trim().toUpperCase() === 'MJUICE' ? 'bg-black' : isLightBrandLogo(brand) ? 'bg-catalystblue' : 'bg-white';

// Enhanced getFillerImage function with Supabase brand logo support
export const getFillerImage = (
  brand: string,
  category: string,
  brandLogoUrl?: string | null,
): string => {
  if (brand.trim().toUpperCase() === 'MJUICE') return MJUICE_LOGO_URL;

  // 1. FIRST PRIORITY: Use Supabase brand logo if available
  if (brandLogoUrl) {
    return brandLogoUrl;
  }

  // 2. SECOND PRIORITY: Default Catalyst image for all products
  return `/images/default.webp`;
};

/** Tailwind classes for the tile a light brand logo needs to stay visible. */
export const LIGHT_LOGO_TILE = 'bg-gradient-to-br from-gray-500 to-gray-400';

/**
 * Is the URL we are about to render a brand-logo stand-in rather than a photo?
 *
 * Answered by comparing against `getFillerImage`'s own output, which works on
 * every surface regardless of how the URL was derived. That matters because the
 * surfaces derive it very differently: the grid card builds the ladder inline,
 * the modal and product page go through `prioritizeProductImages`, and the
 * carts collapse the filler into `primary_image` at data-mapping time and have
 * no way to tell afterwards.
 */
export const isLogoFallback = (
  src: string | undefined | null,
  brand: string | undefined | null,
  category: string | undefined | null,
  brandLogoUrl?: string | null,
): boolean => !!src && src === getFillerImage(brand || '', category || '', brandLogoUrl);

/**
 * True when the rendered image is a brand-logo fallback AND that logo is light.
 *
 * A white logo on a white card, cart line or modal is invisible — it reads as
 * "this product has no image" even though the fallback worked. CAT4's logo is
 * white, which is why `LIGHT_BRAND_LOGOS` exists; the grid card put it on a
 * grey tile and nothing else did, which is how John found the product
 * card/modal mismatch. Every surface that can render a logo now asks this.
 */
export const needsLightLogoTile = (
  src: string | undefined | null,
  brand: string | undefined | null,
  category: string | undefined | null,
  brandLogoUrl?: string | null,
): boolean => isLightBrandLogo(brand) && isLogoFallback(src, brand, category, brandLogoUrl);

/** Show the Budflow upload first, followed by other available product photos. */
export const prioritizeProductImages = (product: {
  budflow_image_url?: string;
  all_images?: string[];
  image?: string;
  primary_image?: string;
  brand_logo_url?: string;
  brand?: string;
  category?: string;
  getBrandLogo?: (brand: string) => string | null;
}): string[] => {
  const {
    budflow_image_url,
    all_images = [],
    image,
    primary_image,
    brand_logo_url,
    brand,
    category,
    getBrandLogo,
  } = product;

  const result: string[] = [];

  if (budflow_image_url?.trim()) result.push(budflow_image_url);
  if (primary_image?.trim() && primary_image !== budflow_image_url) result.push(primary_image);

  // Step 3: Add all_images (excluding duplicates)
  if (all_images && all_images.length > 0) {
    const additionalImages = all_images.filter(
      (img) => img && img.trim() !== '' && img !== primary_image && img !== budflow_image_url,
    );
    result.push(...additionalImages);
  }

  // Step 4: If no primary_image, fall back to image field
  if (result.length === 0 && image && image.trim() !== '') {
    result.push(image);
  }

  // Step 5: If still no images, try brand logo (from cache or product data)
  if (result.length === 0) {
    const logoUrl = brand_logo_url || (getBrandLogo && brand ? getBrandLogo(brand) : null);
    if (logoUrl && logoUrl.trim() !== '') {
      result.push(logoUrl);
    }
  }

  // Step 6: Final fallback to placeholder
  if (result.length === 0) {
    const logoUrl = getBrandLogo && brand ? getBrandLogo(brand) : null;
    return [getFillerImage(brand || '', category || '', logoUrl)];
  }

  return result;
};
